<template>
  <v-container
    fluid
    class="content pa-0"
  >
    <v-row
      v-if="admin"
      :class="{
        'mx-16': $vuetify.breakpoint.mdAndUp,
        'mx-6': $vuetify.breakpoint.smAndDown,
        'my-8': $vuetify.breakpoint.mdAndUp,
        'my-2': $vuetify.breakpoint.smAndDown
      }"
    >
      <v-spacer />
      <v-card
        class="pa-5"
        elevation="6"
        width="90%"
      >
        <tinyMCE
          v-model="home_header"
          :init="{
            content_css: false,
            skin: false,
            setup: function (ed) {
              ed.on('init', function () {
                this.getDoc().body.style.fontSize = '12';
                this.getDoc().body.style.fontFamily = 'Roboto, sans-serif';
              });
            },
            statusbar: false,
            height: 200,
            menubar: false,
            paste_as_text: true,
            language_url: '/langs/de.js',
            language: 'de',
            block_formats: 'Text=p;',
            toolbar:
              'undo redo | bold italic underline '
          }"
        />
      </v-card>
      <v-spacer />
    </v-row>
    <v-row
      v-if="!admin && carouselTextItems.length"
      no-gutters
    >
      <div class="carouselHolder">
        <VueSlickCarousel
          :arrows="false"
          :fade="true"
          :infinite="true"
          :speed="3000"
          :autoplay-speed="5000"
          :autoplay="true"
        >
          <div
            v-for="item in carouselTextItems"
            :key="item"
            :class="{
              'carouselDiv': true,
              'smallCarousel': $vuetify.breakpoint.mdAndDown,
              'largeCarousel': $vuetify.breakpoint.lgOnly,
              'xlCarousel': $vuetify.breakpoint.xlOnly
            }"
          >
            {{ item }}
          </div>

          />
        </VueSlickCarousel>
      </div>
    </v-row>
    <div
      class="d-flex max3Columns flex-wrap justify-space-around mx-auto"
    >
      <StartseiteCard
        v-for="(item, key) in homeItems"
        :key="key"
        class="mb-10"
        :class="{
          'mx-12': $vuetify.breakpoint.xlOnly,
          'mx-6': $vuetify.breakpoint.mdAndUp,
          'mx-2': $vuetify.breakpoint.smAndDown
        }"
        :admin="admin"
        :label="item.label"
        :link="item.link"
        :img-src="item.imgSrc"
        :title-model="item.titleModel"
        :bottom-text-model="item.bottomTextModel"
      />
    </div>
    <TheTextbausteinConfirm
      v-if="admin"
      class="mt-16"
    />
  </v-container>
</template>

<script>
import TheTextbausteinConfirm from '@/components/forms/TheTextbausteinConfirm.vue';
import StartseiteCard from '@/components/forms/StartseiteCard.vue';
import tinyMCE from '@tinymce/tinymce-vue';
import bindingsTextbausteine from '@/store/bindingsTextbausteine';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';

export default {
  components: {
    tinyMCE,
    TheTextbausteinConfirm,
    VueSlickCarousel,
    StartseiteCard
  },
  props: {
    admin: {
      type: Boolean,
      default: () => false
    }
  },
  data: () => ({
    homeItems: [
      {
        label: 'Titel links',
        link: 'leerstand',
        imgSrc: '/img/startseite-leerstand-suche.jpg',
        titleModel: 'home_title_1',
        bottomTextModel: 'home_text_1'
      },
      {
        label: 'Titel mitte',
        link: 'leerstandeditor/neu',
        imgSrc: '/img/startseite-leerstand.jpeg',
        titleModel: 'home_title_middle',
        bottomTextModel: 'home_text_middle'
      },
      {
        label: 'Titel rechts',
        link: 'grundstuecke',
        imgSrc: '/img/startseite-standortsuche.jpg',
        titleModel: 'home_title_right',
        bottomTextModel: 'home_text_right'
      },
      {
        label: 'Titel links unten',
        link: 'businessparks',
        imgSrc: '/img/startseite-businessparks.jpeg',
        titleModel: 'home_title_middle2',
        bottomTextModel: 'home_text_middle2'
      },
      {
        label: 'Titel mitte unten',
        link: 'technologiezentren',
        imgSrc: '/img/startseite-technologiezentren.jpeg',
        titleModel: 'home_title_left',
        bottomTextModel: 'home_text_left'
      },
      {
        label: 'Titel rechts unten',
        link: 'foerderungen',
        imgSrc: '/img/startseite-leerstand-melden.jpg',
        titleModel: 'home_title_2',
        bottomTextModel: 'home_text_2'

      }
    ]
  }),
  computed: {
    ...bindingsTextbausteine(),
    carouselTextItems() {
      const doc = new DOMParser().parseFromString(this.home_header, 'text/html');
      if (doc) {
        const paragraphs = doc.querySelectorAll('p');
        if (paragraphs) {
          const paragraphsArray = Array.from(paragraphs);
          if (paragraphsArray.length) {
            return paragraphsArray.map(p => p.innerText);
          }
        }
      }
      return [];
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (this.admin && this.$store.state.isDirty) {
      await this.$root.$confirm({
        title: 'Zurück ohne Speichern?',
        message: 'Bitte bestätigen oder verwerfen Sie Ihre Änderungen.'
      });
    } else {
      next();
    }
  }
};
</script>
<style scoped>
  .content {
    height: calc(100vh - 92px);
    overflow: auto;
  }

  .fotoHolder {
    border-radius: 5px 5px 0px 0px !important;
  }

  .carouselHolder {
    width: calc(90% - 10px);
    margin-left: auto;
    margin-right: auto;
    margin-top: 10px;
    margin-bottom: 20px;
  }

  .carouselDiv {
    text-align: center;
    color: white;
    margin-top: 15px;
    display: flex !important;
    justify-content: center;
    align-content: center;
    flex-direction: column;
  }

  .smallCarousel {
    font-size: 22px;
    font-weight: 800;
    height: 90px;
  }

  .largeCarousel {
    font-size: 30px;
    font-weight: 800;
    height: 100px;
  }

  .xlCarousel {
    font-size: 36px;
    font-weight: 800;
    height: 120px;
  }

  /** max width to enforce 3 columns on very large screen */
  .max3Columns {
    max-width: 1800px;
  }

</style>
